import _ from 'lodash';
import { baseUtils } from '../utils/baseUtils.js';
import Wix from '../sdk/WixSdkWrapper';
import translationUtils from '../utils/translationUtils';
import window from '../sdk/windowWrapper';
import { experimentsWrapper } from '../sdk/experimentsWrapper.js';

var ItemActions = /*#__PURE__*/function () {
  function ItemActions() {
    this.getLoveCount = this.getLoveCount.bind(this);
    this.wasInit = false;
    this.loveCounts = {};
    this.fetchSiteInfo();
  }

  var _proto = ItemActions.prototype;

  _proto.initWidgetData = function initWidgetData(config) {
    this.config = config;

    if (config.compId) {
      this.compId = config.compId;
    }

    if (config.pageId) {
      this.pageId = config.pageId;
    }

    if (config.styleId) {
      this.styleId = config.styleId;
    }

    if (config.pageUrl) {
      this.pageUrl = config.pageUrl;
    }

    if (typeof config.isStoreGallery === 'boolean') {
      this.isStoreGallery = config.isStoreGallery;
    }

    if (config.galleryId) {
      this.galleryId = config.galleryId;
    }

    if (config.viewMode) {
      this.viewMode = config.viewMode.toLowerCase();
    }

    if (config.fullscreenUrl) {
      this.siteUrl = this.fullscreenUrl = this.normalizeFullscreenUrl(config.fullscreenUrl);

      try {
        this.siteUrl = this.fullscreenUrl.match(/.*\..*\//g)[0];
      } catch (e) {//
      }
    }

    if (config.onLoveCountsFetched) {
      this.onLoveCountsFetched = config.onLoveCountsFetched;
    }

    this.baseUrl = config.baseUrl || '//progallery.wixapps.net';

    if (config.reachLevel) {
      this.setReachLevel(config.reachLevel);
    }

    if (!baseUtils.isSSR() && this.viewMode === 'site' && this.galleryId && this.galleryId !== '') {
      this.getStats();
    }

    this.wasInit = config;
    return Date.now();
  }
  /**
   * Sometimes we may get a full screen url with some additional parameters (like we get right after the user logs in. We need to remove them)
   */
  ;

  _proto.normalizeFullscreenUrl = function normalizeFullscreenUrl(fullscreenUrl) {
    var querylessUrl = fullscreenUrl;

    if (fullscreenUrl) {
      querylessUrl = fullscreenUrl.split('?')[0];
    }

    return querylessUrl;
  };

  _proto.fetchSiteInfo = function fetchSiteInfo() {
    var _this = this;

    var href;

    try {
      href = window.location.href;
    } catch (e) {
      href = '';
    }

    if (baseUtils.isInWix()) {
      this.siteInfo = {};
      Wix.getSiteInfo(function (res) {
        _this.siteInfo = res;
      });
    } else {
      this.siteInfo = {
        url: href,
        baseUrl: href,
        siteTitle: 'Wix Pro Gallery',
        siteDescription: 'The best gallery any Wix user has ever seen!',
        siteKeywords: 'gallery,photos,photographer,professional'
      };
    }
  };

  _proto.getSiteUrl = function getSiteUrl() {
    return this.siteInfo.url;
  };

  _proto.getStats = function getStats() {
    var _this2 = this;

    if (this.viewMode !== 'site' || baseUtils.isDev() || baseUtils.isTest()) {
      return;
    }

    if (!this.galleryId || this.galleryId === '' || this.galleryId.length < 10) {
      console.log('galleryId id', this.galleryId, typeof this.galleryId);
      console.error('get stats error - no galleryId');
      return;
    }

    fetch(this.baseUrl + "/_api/pro-gallery-webapp/v1/gallery/" + this.galleryId + "/stats/properties").then(function (res) {
      return res.json();
    }).then(function (res) {
      try {
        if (res.properties) {
          _this2.statsProps = JSON.parse(res.properties);
        } else if (res.statsToken) {
          // hack for art-store in albums (no res.properties)
          _this2.statsProps = {
            instance_id: _this2.config.instanceId,
            set_id: _this2.galleryId
          };
        }

        _this2.statsToken = res.statsToken;
      } catch (e) {
        console.error('Failed getting stats props', e);
      }
    });
    var instanceId;

    try {
      instanceId = this.config.instanceId || window.instanceId;
    } catch (e) {
      instanceId = '';
    }

    if (!instanceId) {
      console.warn('cannot report love counter - no instance id');
    } else {
      fetch(this.baseUrl + "/_api/pro-gallery-webapp/v1/gallery/" + this.galleryId + "/" + instanceId + "/stats").then(function (res) {
        return res.json();
      }).then(function (res) {
        try {
          if (res && res.photoId2Love) {
            _this2.loveCounts = res.photoId2Love;

            if (_this2.onLoveCountsFetched) {
              _this2.onLoveCountsFetched(_this2.loveCounts);
            }
          }
        } catch (e) {
          console.error('Failed getting love counts', e);
        }
      });
    }
  };

  _proto.getLoveCount = function getLoveCount(photoId) {
    return Math.max(0, this.loveCounts[photoId]) || 0;
  };

  _proto.html2img = function html2img(itemDto, callback) {
    import(
    /* webpackChunkName: "html2canvas" */
    'html2canvas').then(function (html2canvas) {
      try {
        var div = window.document.createElement('div');
        div.innerHTML = itemDto.html;
        div.style.boxSizing = 'border-box';
        div.style.background = itemDto.style.bgColor;
        div.style.position = 'absolute';
        div.style.top = 0;
        div.style.left = 0;
        div.style.zIndex = -1;
        div.className = 'text-item';
        window.document.body.appendChild(div);
        html2canvas(div).then(function (canvas) {
          div.remove();
          var url = canvas.toDataURL();

          if (typeof callback === 'function') {
            callback(url);
          }
        });
      } catch (e) {
        if (typeof callback === 'function') {
          callback('');
        }
      }
    });
  };

  _proto.share = function share(type, itemDto, numOfItems) {
    if (baseUtils.isDemo()) {
      return;
    }

    if (numOfItems) {
      // itemDto.numOfItems is not extensible because it is being passed in props.
      itemDto.numOfItems = numOfItems;
    }

    this.shareImp(type, itemDto);
  };

  _proto.downloadTextItem = function downloadTextItem(itemDto) {
    this.html2img(itemDto, function (url) {
      try {
        url = url.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
        window.open(url);
      } catch (e) {//
      }
    });
  };

  _proto.getReachLevel = function getReachLevel(increment) {
    var inc = Number(increment || 0);
    var rl;

    if (_.isUndefined(this.reachLevel)) {
      var ls = baseUtils.getLocalStorage();
      rl = Number(ls[this.siteUrl + "|reach-level"] || 0) + inc;
    } else {
      rl = this.reachLevel + inc;
    }

    return rl;
  };

  _proto.setReachLevel = function setReachLevel(rl) {
    if (!(rl > 0)) {
      rl = 0;
    }

    try {
      var origRl = this.getReachLevel(0); // if this user already registered a reach-level for this site (already saw it) don't register again

      if (rl > 0 && origRl === 0 && _.isUndefined(this.reachLevel)) {
        var ls = baseUtils.getLocalStorage();
        ls[this.siteUrl + "|reach-level"] = rl;
        this.reachLevel = rl;
      }
    } catch (e) {
      console.warn('set reach level error', e);
    }
  };

  _proto.getShareUrl = function getShareUrl(item) {
    if (experimentsWrapper.getExperimentBoolean('specs.pro-gallery.newFullscreenShare')) {
      return this.pageUrl + '?pgid=' + this.compId.replace('comp-', '') + '-' + this.getItemId(item);
    } else {
      return this.fullscreenUrl + '/' + this.compId + '/' + this.getItemId(item) + '/' + item.idx + '/' + encodeURIComponent('?i=' + item.idx + '&p=' + this.pageId + '&s=' + this.styleId + '&rl=' + this.getReachLevel(1) + (item.hashtag ? '&ht=' + item.hashtag : ''));
    }
  };

  _proto.getItemId = function getItemId(item) {
    return item.id || item.photoId || item.itemId;
  };

  _proto.shareImp = function shareImp(type, itemDto, callback) {
    function openWindow(url, source) {
      try {
        if (baseUtils.isiOS() && source === 'Email') {
          window.location.href = url;
        } else {
          var windowRef = window.open(url, source + ' Share', 'height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no');
          setTimeout( // When the mailto url opens. In some configurations the new window redirects to the configured mail client (e.g. gmail).
          // In other instances a desktop client is opened (e.g. Outlook) and the new window is blank. This tests for that situation and closes the window if it happens.
          function () {
            try {
              if (source === 'Email' && windowRef.location.hasOwnProperty('pathname') && windowRef.location.pathname === 'blank') {
                windowRef.close();
              }
            } catch (e) {
              console.warn('Could not close mailto window');
            }
          }, 5000);
        }
      } catch (e) {//
      }
    }

    var item = {
      id: this.getItemId(itemDto),
      idx: itemDto.idx || 0,
      url: itemDto.createUrl && itemDto.createUrl('sample', 'img'),
      title: itemDto.title || itemDto.description || this.siteInfo.siteTitle,
      hashtag: itemDto.hashtag
    };
    var shareUrl = encodeURIComponent(this.getShareUrl(item));
    var shareTitle = encodeURIComponent(item.title || '');
    var shareImageUrl = encodeURIComponent(item.url);
    var shareKeywords = encodeURIComponent(this.siteInfo.siteKeywords);
    var shareMessage = encodeURIComponent("" + this.getShareUrl(item));

    if (!_.isFunction(callback)) {
      callback = openWindow;
    }

    switch (type) {
      case 'facebook':
        callback('http://www.facebook.com/sharer/sharer.php?u=' + shareUrl + '&t=' + shareTitle, 'Facebook');
        break;

      case 'twitter':
        {
          var twitterMaxLength = 110;
          var shareUrlExtraData = '&amp;text=' + (shareTitle === 'undefined' ? '' : shareTitle);

          if (shareUrlExtraData.length > twitterMaxLength) {
            shareUrlExtraData = shareUrlExtraData.slice(0, twitterMaxLength - 3) + '...';
          } else {
            var shareKeywordsUrlComponent = '&amp;hashtags=' + shareKeywords;

            if ((shareUrlExtraData + shareKeywordsUrlComponent).length <= twitterMaxLength) {
              shareUrlExtraData += shareKeywordsUrlComponent;
            }
          }

          callback('https://twitter.com/intent/tweet?url=' + shareUrl + shareUrlExtraData, 'Twitter');
          break;
        }

      case 'pinterest':
        callback('https://pinterest.com/pin/create/button/?url=' + shareUrl + '&media=' + shareImageUrl.replace('webp', 'jpg') + '&description=' + shareTitle, 'Pinterest');
        break;

      case 'google':
        callback('https://plus.google.com/share?url=' + shareUrl, 'Google Plus');
        break;

      case 'tumblr':
        callback('http://www.tumblr.com/share/link?url=' + shareUrl, 'Tumblr');
        break;

      case 'email':
        callback('mailto:?Subject=' + shareTitle + '&body=' + shareMessage, 'Email');
        break;

      default:
        break;
    }
  };

  _proto.reportLoveToStats = function reportLoveToStats(photoId, value) {
    try {
      if (!this.statsProps || !this.statsProps.instance_id) {
        this.getStats();
        return;
      }

      var statsProps = _.merge(this.statsProps, {
        photo_id: photoId
      });

      var statsToken = this.statsToken || window.statsToken;
      var uniqueUUID = baseUtils.generateUUID();
      fetch(window.location.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + statsToken, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          messageId: uniqueUUID,
          metrics: [{
            type: 'photo',
            reportMetrics: [{
              name: 'love',
              value: String(value)
            }],
            properties: statsProps
          }]
        })
      }).then(function (data) {
        console.log('Success report love', data);
      });
    } catch (e) {
      console.error('Error reporting love to stats', e);
    }
  };

  _proto.getLoveStorageKey = function getLoveStorageKey(photoId) {
    return 'pro-gallery-item-love-' + photoId;
  };

  _proto.isLoved = function isLoved(photoId) {
    try {
      if (typeof baseUtils.getLocalStorage() === 'undefined') {
        return false;
      }

      return !!baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] || false;
    } catch (e) {
      console.warn('isLoved failed', e);
    }
  };

  _proto.toggleLove = function toggleLove(photoId, forceVal) {
    try {
      if (!baseUtils.getLocalStorage()) {
        return false;
      }

      var inc;

      if (this.isLoved(photoId) && forceVal !== true || forceVal === false) {
        // unlove
        baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] = '';
        inc = -1;
      } else {
        // love
        baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] = true;
        inc = 1;
      }

      this.reportLoveToStats(photoId, inc);
    } catch (e) {
      console.warn('toggleLove failed', e);
    }
  };

  _proto.isFirstLoveClick = function isFirstLoveClick(photoId) {
    try {
      return baseUtils.getLocalStorage()[this.getLoveStorageKey(photoId)] === undefined;
    } catch (e) {
      console.warn('isFirstLoveClick failed', e);
    }
  };

  _proto.postLoveActivity = function postLoveActivity(item) {
    var postSocialTrackActivity = function postSocialTrackActivity(data) {
      try {
        var activity = {
          type: Wix.Activities.Type.SOCIAL_TRACK,
          info: {
            type: data.activityType,
            channel: data.activityNetwork,
            itemInfo: {
              itemUrl: data.url,
              itemId: data.id,
              itemType: data.type.toUpperCase()
            }
          },
          details: {
            additionalInfoUrl: data.url,
            summary: ''
          },
          contactUpdate: null
        };

        var onSuccess = function onSuccess(d) {
          console.log('Activity ID: ' + d.activityId + ', Contact ID: ' + d.contactId);
        };

        var onFailure = function onFailure(d) {
          console.log('Failure message:', d);
        };

        Wix.Activities.postActivity(activity, onSuccess, onFailure);
      } catch (e) {
        console.log('error posting activity.', e);
      }
    };

    var itemId = this.getItemId(item);

    if (this.isFirstLoveClick(itemId)) {
      postSocialTrackActivity({
        activityType: 'LOVE',
        activityNetwork: 'SITE',
        id: itemId,
        url: this.getShareUrl(item),
        type: item.type
      });
    }
  };

  _proto.showTooltip = function showTooltip(e, key, pos) {
    if (document.getElementsByClassName('pro-tooltip').length >= 1) {
      return;
    }

    var target = e.currentTarget;

    if (!target) {
      return;
    }

    var offset = target.getBoundingClientRect();
    var top = offset.top;
    var left = offset.left;
    var css;
    var innerWidth;

    try {
      innerWidth = window.innerWidth;
    } catch (exception) {
      innerWidth = 980;
    }

    if (typeof pos === 'undefined') {
      pos = left > innerWidth / 2 ? 'right' : 'left';
    }

    switch (pos) {
      case 'top':
        css = {
          top: top - 30 + 'px',
          left: left + 28 + 'px',
          opacity: 1
        };
        break;

      case 'right':
        css = {
          top: top - 4 + 'px',
          left: left - 20 + 'px',
          opacity: 1
        };
        break;

      default:
      case 'left':
        css = {
          top: top - 4 + 'px',
          left: left + 40 + 'px',
          opacity: 1
        };
        break;
    }

    css['pointer-events'] = 'none';
    var div = window.document.createElement('div');
    div.classList.add('pro-tooltip');
    div.classList.add(pos);
    Object.assign(div.style, css);
    div.innerHTML = translationUtils.getByKey(key);
    window.document.body.appendChild(div);
  };

  _proto.hideTooltip = function hideTooltip() {
    window.document.body.removeChild(document.getElementsByClassName('pro-tooltip')[0]);
  };

  _proto.toggleTooltip = function toggleTooltip(e, key, pos) {
    var hasTooltip = document.getElementsByClassName('pro-tooltip').length === 1;

    if (hasTooltip) {
      this.hideTooltip();
    } else {
      this.showTooltip(e, key, pos);
    }
  };

  _proto.viewClassName = function viewClassName(layout, device) {
    if (layout === 'fullscreen') {
      return device === 'desktop' ? 'fullscreen-icon' : '';
    } else {
      return '';
    }
  };

  return ItemActions;
}();

export { ItemActions as default };
export var itemActions = new ItemActions();